module.exports = __webpack_public_path__ + "21d34d950b1fb1c224623ca155aa4838.png";